import styled from '@emotion/styled'

export const IntervalWrapper = styled.div`
    padding: 10px;
    width: 100%;
    border: 1px solid #cccccc88;
    border-radius: 8px;
    background-color: var(--chakra-colors-secondary-background);
`
